module.exports = __webpack_public_path__ + "img/regional_distributor.jpg?v=07e25d92";